export const FAILED_LOGIN = 'FAILED_LOGIN';
export const PERFORM_LOGOUT = 'PERFORM_LOGOUT';

export const ADD_ERRORS = 'ADD_ERRORS';
export const CLEAN_ERRORS = 'CLEAN_ERRORS';

export const UPDATE_USER = 'UPDATE_USER';
export const ADD_ADMIN_USERS = 'ADD_ADMIN_USERS';

export const ADD_WEBINARS = 'ADD_WEBINARS';
export const SET_WEBINARS = 'SET_WEBINARS';
export const UPDATE_WEBINAR = 'UPDATE_WEBINAR';
export const SET_TEMP_WEBINAR = 'SET_TEMP_WEBINAR';
export const ADD_USERS_WEBINARS = 'ADD_USERS_WEBINARS';
export const CLEAN_WEBINARS = 'CLEAN_WEBINARS';
export const CLEAN_USERS_WEBINARS = 'CLEAN_USERS_WEBINARS';
export const ADD_ADMIN_DASHBOARD_USERS = 'ADD_ADMIN_DASHBOARD_USERS';
export const ADD_ADMIN_USRES_WEBINARS = 'ADD_ADMIN_USRES_WEBINARS_SAGA';

export const ADD_ADMIN_WEBINARS = 'ADD_ADMIN_WEBINARS';
export const ADD_ADMIN_DASHBOARD_WEBINARS = 'ADD_ADMIN_DASHBOARD_WEBINARS';

export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';

export const ADD_VIMEO_VIDEO_DATA = 'ADD_VIMEO_VIDEO_DATA';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const SET_QUIZ_STATUS = 'SET_QUIZ_STATUS';

export const ADD_HOSPITAL_SUGGESTIONS = 'ADD_HOSPITAL_SUGGESTION';
export const NEW_HOSPITAL_SUGGESTION = 'NEW_HOSPITAL_SUGGESTION';
export const ADD_COUNTY_SUGGESTIONS = 'ADD_COUNTY_SUGGESTIONS';
export const ADD_SPONSOR_SUGGESTIONS = 'ADD_SPONSOR_SUGGESTIONS';

export const SET_EDIT_USER = 'SET_EDIT_USER';

export const START_REQUEST = 'START_REQUEST';
export const END_REQUEST = 'END_REQUEST';

export const SET_PROFILE_CONFIRMATION = 'SET_PROFILE_CONFIRMATION';

export const ADD_SPONSORS = 'ADD_SPONSORS';
export const CLEAN_SPONSORS = 'CLEAN_SPONSORS';
export const SET_TEMP_SPONSOR = 'SET_TEMP_SPONSOR';
export const ADD_ADMIN_SPONSORS = 'ADD_ADMIN_SPONSORS';



/** WEBPACK FOOTER **
 ** ./src/constants/actions.js
 **/